import React from 'react';
import { Block } from '../block/block.react-component';
import { Skeleton } from '../skeleton/skeleton.react-component';
import styles from "./image-skeleton.module.css";
/**
 * ### ImageSkeleton
 *
 * A skeleton component for placeholding images.  A Udemy logotype appear.
 */

export const ImageSkeleton = props => {
  return /*#__PURE__*/React.createElement(Skeleton, Object.assign({
    className: styles.wrapper
  }, props), /*#__PURE__*/React.createElement(Block, null), /*#__PURE__*/React.createElement("div", {
    className: styles.u
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 112 112"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-loading-logotype, var(--color-white))",
    fillRule: "evenodd",
    d: "m57 23.2 24.4 14v-14L57 9.3l-24.3 14V37L57 23.2ZM45.4 48.8H32.7v31.7c0 7.2 2.3 12.6 6.8 16.4a25.9 25.9 0 0 0 17.4 5.8c7 0 12.9-2 17.5-5.8s7-9.4 7-16.7V48.8H68.6v30.5c0 8-6 11.9-11.6 11.9s-11.6-3.9-11.6-11.8V48.8Z",
    clipRule: "evenodd"
  }))));
};
//# sourceMappingURL=image-skeleton.react-component.js.map